import type { FC } from "react";

import type { ProductAttribute } from "@locators/components/StoreLocator";

import { FlavourTile } from "./FlavourTile";

import styles from "../StoreDetailsProductsByBrand.module.scss";

const BRAND_LABELS_BY_FLAVOUR = {
  EVO: "evo",
  LYO: "lyo",
} as const;

type BrandLabelByFlavourType = (typeof BRAND_LABELS_BY_FLAVOUR)[keyof typeof BRAND_LABELS_BY_FLAVOUR];

type FlavourTileProps = {
  brandLabel: BrandLabelByFlavourType;
  attribute?: ProductAttribute;
  groupName: string;
};

export const BrandGroup: FC<FlavourTileProps> = ({ brandLabel, attribute, groupName }) => {
  if (!attribute?.values?.length) {
    return null;
  }

  return (
    <div className={styles.storeDetailsProductsSticksContainer}>
      <h3 className={styles.storeDetailsProductsCategoryTitle}>{brandLabel}</h3>
      <div className={styles.storeDetailsProductsCardsTiles}>
        {attribute.values.map((flavour) => (
          <FlavourTile key={flavour.value} flavour={flavour} attribute={attribute} groupName={groupName} />
        ))}
      </div>
    </div>
  );
};

export { BRAND_LABELS_BY_FLAVOUR };
